import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePricingCategory } from 'src/api/updatePricingCategory/updatePricingCategory';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';
import type { TUpdatePricingCategoryRequest } from 'src/api/updatePricingCategory/types';

export const useUpdatePricingCategory = (priceSchemeId: string) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    async ({ categoryId, displayOrder, newParentId, newName }: TUpdatePricingCategoryRequest) =>
      updatePricingCategory({
        priceSchemeId,
        categoryId,
        displayOrder,
        newParentId,
        newName,
      }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.pricingCategories, priceSchemeId] });
      },
      onError: () => {
        showSnackbar({
          status: SnackbarStatus.ERROR,
          message: 'We have been unable to complete your request',
        });
      },
    },
  );
};
